export const SUBTASK_PARAM_TYPES = {
  STRING: 'STRING',
  NUMBER: 'NUMBER',
  DATE: 'DATE',
  BOOLEAN: 'BOOLEAN'
};

export const STATUS_TYPES = {
  CANCELED: 'CANCELED',
  DONE: 'DONE',
  ERROR: 'ERROR',
  INPROGRESS: 'INPROGRESS',
  PAUSED: 'PAUSED',
  UNDEFINED: '',
  properties: {
    CANCELED: {
      name: 'CANCELED',
      value: 'CANCELED',
      humanValue: 'CANCELED',
      icon: ['far', 'times-circle'],
      bootstrapVariant: 'danger'
    },
    DONE: {
      name: 'DONE',
      value: 'DONE',
      humanValue: 'DONE',
      icon: ['far', 'check-circle'],
      bootstrapVariant: 'success'
    },
    ERROR: {
      name: 'ERROR',
      value: 'ERROR',
      humanValue: 'ERROR',
      icon: 'exclamation-circle',
      bootstrapVariant: 'warning'
    },
    INPROGRESS: {
      name: 'INPROGRESS',
      value: 'INPROGRESS',
      humanValue: 'IN PROGRESS',
      icon: 'spinner',
      bootstrapVariant: 'primary'
    },
    PAUSED: {
      name: 'PAUSED',
      value: 'PAUSED',
      humanValue: 'PAUSED',
      icon: ['far', 'pause-circle'],
      bootstrapVariant: 'info'
    },
    UNDEFINED: {
      name: 'UNDEFINED',
      value: '',
      humanValue: 'UNDEFINED',
      icon: ['far', 'question-circle'],
      bootstrapVariant: 'secondary'
    }
  }
};

export const NODE_TYPES = {
  SUBTASK: 'SUBTASK',
  CONNECTION: 'CONNECTION',
  properties: {
    SUBTASK: {
      name: 'SUBTASK',
      value: 'SUBTASK',
      iconType: 'square',
      iconColor: '#f7fcb9'
    },
    CONNECTION: {
      name: 'CONNECTION',
      value: 'CONNECTION',
      iconType: 'circle',
      iconColor: '#31a354'
    }
  }
};
